export const AccessTypeCode = {
    AccessTypeUnspecified: 0,
    AccessTypeNobody: 1,
    AccessTypeOnlyAddress: 2,
    AccessTypeEverybody: 3,
    AccessTypeAnyOfAddresses: 4,
};
export const AccessType = {
    AccessTypeUnspecified: 'Unspecified',
    AccessTypeNobody: 'Nobody',
    AccessTypeOnlyAddress: 'Only Address',
    AccessTypeEverybody: 'Everybody',
    AccessTypeAnyOfAddresses: 'Any of Addresses',
};
export const ValidatorUptimeStatus = {
    Proposed: 'proposed',
    Signed: 'signed',
    Missed: 'missed',
};
